<script lang="ts" setup>
const emit = defineEmits(["valueChanged"]);

const props = defineProps<{
    id?: string;
    value?: string;
    name?: string;
    bordered?: boolean;
    disabled?: boolean;
}>();

const handleChange = (event: Event) => {
    // segurança extra
    if (props.disabled) return;

    emit("valueChanged", (event.target as HTMLSelectElement).value);
};
</script>

<template>
    <select
        :id="props.id"
        :class="[props.bordered ? 'bordered-input' : 'ringed-input']"
        :disabled="props.disabled"
        :name="props.name"
        :value="props.value"
        class="text-input"
        @change="handleChange"
    >
        <slot></slot>
    </select>
</template>
